import { __name } from './chunk-2JTKI4GS.mjs';
import { matchPath } from 'react-router-dom';
import { isLoadableComponent } from './utils.mjs';

async function ensureReady(routes, pathname) {
  await Promise.all(
    routes.map((route) => {
      const match = matchPath(pathname || window.location.pathname, route);
      if (match && route && route.component && isLoadableComponent(route.component) && route.component.load) {
        return route.component.load();
      }
      return void 0;
    })
  );
  return Promise.resolve(
    window.__SERVER_APP_STATE__
  );
}
__name(ensureReady, "ensureReady");

export { ensureReady };
//# sourceMappingURL=ensureReady.mjs.map
//# sourceMappingURL=ensureReady.mjs.map